export default "/images/check-act.svg?42735c06f4c37f4361442ddc576b0570";